import React from 'react';
import { ClientsBanner } from './ClientsBanner';
import { clients } from '../../assets/data/clientsData'
import './Clients.css';
export const Clients = () => {

    return (
        <div className='clients'>
            <ClientsBanner/>
            <div className='clients-container'>
                <div className='clients-images'>
                    {clients && clients.map(image => (
                        <img key={image} src={image} alt="clientsimage" />
                    ))}
                </div>
            </div>
        </div>
    )
}
